var KNewsWidgetChipStyle;
(function (KNewsWidgetChipStyle) {
    KNewsWidgetChipStyle["Outlined"] = "outlined";
    KNewsWidgetChipStyle["Filled"] = "filled";
})(KNewsWidgetChipStyle || (KNewsWidgetChipStyle = {}));
var KNewsWidgetImagePosition;
(function (KNewsWidgetImagePosition) {
    KNewsWidgetImagePosition["ImageTop"] = "IMAGE_TOP";
    KNewsWidgetImagePosition["ImageBottom"] = "IMAGE_BOTTOM";
    KNewsWidgetImagePosition["ImageLeft"] = "IMAGE_LEFT";
    KNewsWidgetImagePosition["ImageRight"] = "IMAGE_RIGHT";
})(KNewsWidgetImagePosition || (KNewsWidgetImagePosition = {}));
var KNewsWidgetChipPosition;
(function (KNewsWidgetChipPosition) {
    KNewsWidgetChipPosition["Center"] = "CENTER";
    KNewsWidgetChipPosition["Left"] = "LEFT";
    KNewsWidgetChipPosition["Right"] = "RIGHT";
})(KNewsWidgetChipPosition || (KNewsWidgetChipPosition = {}));
var KNewsWidgetButtonPosition;
(function (KNewsWidgetButtonPosition) {
    KNewsWidgetButtonPosition["Center"] = "CENTER";
    KNewsWidgetButtonPosition["Left"] = "LEFT";
    KNewsWidgetButtonPosition["Right"] = "RIGHT";
})(KNewsWidgetButtonPosition || (KNewsWidgetButtonPosition = {}));
var KNewsWidgetIconPosition;
(function (KNewsWidgetIconPosition) {
    KNewsWidgetIconPosition["Left"] = "LEFT";
    KNewsWidgetIconPosition["Right"] = "RIGHT";
})(KNewsWidgetIconPosition || (KNewsWidgetIconPosition = {}));
var KNewsWidgetDisplayMode;
(function (KNewsWidgetDisplayMode) {
    KNewsWidgetDisplayMode["Article"] = "ARTICLE";
    KNewsWidgetDisplayMode["Image"] = "IMAGE";
})(KNewsWidgetDisplayMode || (KNewsWidgetDisplayMode = {}));
var KNewsWidgetTextBackgroundType;
(function (KNewsWidgetTextBackgroundType) {
    KNewsWidgetTextBackgroundType["NoBackground"] = "NO_BACKGROUND";
    KNewsWidgetTextBackgroundType["TopEffect"] = "TOP_EFFECT";
    KNewsWidgetTextBackgroundType["BottomEffect"] = "BOTTOM_EFFECT";
    KNewsWidgetTextBackgroundType["Unicolor"] = "UNICOLOR";
})(KNewsWidgetTextBackgroundType || (KNewsWidgetTextBackgroundType = {}));
var KNewsWidgetVerticalTextAlignType;
(function (KNewsWidgetVerticalTextAlignType) {
    KNewsWidgetVerticalTextAlignType["Center"] = "CENTER";
    KNewsWidgetVerticalTextAlignType["Bottom"] = "BOTTOM";
    KNewsWidgetVerticalTextAlignType["Top"] = "TOP";
})(KNewsWidgetVerticalTextAlignType || (KNewsWidgetVerticalTextAlignType = {}));

export { KNewsWidgetButtonPosition, KNewsWidgetChipPosition, KNewsWidgetChipStyle, KNewsWidgetDisplayMode, KNewsWidgetIconPosition, KNewsWidgetImagePosition, KNewsWidgetTextBackgroundType, KNewsWidgetVerticalTextAlignType };
//# sourceMappingURL=index.props.js.map
